import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {Link, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getClients} from "../../store/reducers/ClientsSlice";
import Pagination from "../common/Pagination";
import OrdersSearch from "./components/OrdersSearch";
import {OrdersTable} from "./components/OrdersTable";
import {getOrders} from "../../store/reducers/OrdersSlice";

interface OrdersScreenProps {
}

export const OrdersScreen: React.FC<OrdersScreenProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    const ordersState = useAppSelector((state) => state.orders);

    const perPage = parseInt(new URLSearchParams(window.location.search).get('perPage') || '80', 10);

    useEffect(() => {
        dispatch(getOrders());
    }, [routeParams]);

    return (
        <LoggedInView fullWidth={true}>
            <OrdersSearch />
            <OrdersTable />
            <Pagination totalItems={ordersState.total} itemsPerPage={perPage}  />
        </LoggedInView>
    )
}

